import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaViolenciaGeneroByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaViolenciaGeneroByUser = () => {
  const [loadingGetDeclaracionJuradaViolenciaGeneroByUser, setLoadingGetDeclaracionJuradaViolenciaGeneroByUser] = useState(false);
  const [successGetDeclaracionJuradaViolenciaGeneroByUser, setSuccessGetDeclaracionJuradaViolenciaGeneroByUser] = useState(false);
  const [errorGetDeclaracionJuradaViolenciaGeneroByUser, setErrorGetDeclaracionJuradaViolenciaGeneroByUser] = useState<any>(null);
  const [dataGetDeclaracionJuradaViolenciaGeneroByUser, setDataDeclaracionJuradaViolenciaGeneroByUser] = useState<any>(null);

  const [statusGetDeclaracionJuradaViolenciaGeneroByUser, setStatusGetDeclaracionJuradaViolenciaGeneroByUser] =
    useState<StatusGetDeclaracionJuradaViolenciaGeneroByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaViolenciaGeneroByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionJuradaViolenciaGeneroByUser(true);
    setSuccessGetDeclaracionJuradaViolenciaGeneroByUser(false);
    setErrorGetDeclaracionJuradaViolenciaGeneroByUser(null);

    try {
      const res = await apirecord.getSolicitudDeclaracionJuradaFuerzaMayorByUser(userId, expedienteId);

      setStatusGetDeclaracionJuradaViolenciaGeneroByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetDeclaracionJuradaViolenciaGeneroByUser(true);
      setDataDeclaracionJuradaViolenciaGeneroByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaViolenciaGeneroByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaViolenciaGeneroByUser(err);
      console.error("Error en getDeclaracionJuradaViolenciaGeneroByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionJuradaViolenciaGeneroByUser(false);
    }
  };


  return {
    getDeclaracionJuradaViolenciaGeneroByUser,
    loadingGetDeclaracionJuradaViolenciaGeneroByUser,
    successGetDeclaracionJuradaViolenciaGeneroByUser,
    errorGetDeclaracionJuradaViolenciaGeneroByUser,
    dataGetDeclaracionJuradaViolenciaGeneroByUser,
    statusGetDeclaracionJuradaViolenciaGeneroByUser
  };
};

export default useGetDeclaracionJuradaViolenciaGeneroByUser;
